/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api.js";

// Centralisation des routes API
const API_ROUTES = {
  ADD_PRODUCT: `/api/product_add`,
  GET_PRODUCTS: `/api/products/products_get`,
  GET_PRODUCT_BY_ID: `/api/products/get_product_by_id`,
  UPDATE_PRODUCT: `/api/product/update`,
  DELETE_PRODUCT: `/api/product/delete`,
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

// Action for adding a product
export const productAdd = createAsyncThunk(
  "product/productAdd",
  async (product, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.ADD_PRODUCT, product, {
        withCredentials: true,
      });
      //console.log("API Response:", data); // Log the API response
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error adding product", error);
      //return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Action for fetching products
export const get_products = createAsyncThunk(
  "product/get_products",
  async (
    { searchValue, parPage, page },
    { rejectWithValue, fulfillWithValue },
  ) => {
    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_PRODUCTS}?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true },
      );
      // console.log("API Response products get:", data); // Log the API response
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error fetching products", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Action for fetching product by id
export const get_product_by_id = createAsyncThunk(
  "product/get_product_by_id",
  async (productId, { rejectWithValue, fulfillWithValue }) => {
    console.log("prdo id", productId);
    try {
      const { data } = await api.get(
        `${API_ROUTES.GET_PRODUCT_BY_ID}/${productId}`,
        { withCredentials: true },
      );
      console.log("API Response product by id:", data); // Log the API response
      return fulfillWithValue(data);
    } catch (error) {
      console.error("Error fetching products", error);
      // return rejectWithValue(error.response?.data.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
// Action for updating product
export const productUpdate = createAsyncThunk(
  "product/productUpdate",
  async (product, { rejectWithValue, fulfillWithValue }) => {
    //console.log("le produit " , product);
    try {
      // Remplacer :id par l'identifiant réel du produit
      const { data } = await api.put(API_ROUTES.UPDATE_PRODUCT, product, {
        withCredentials: true,
      });
      //console.log("API Response product update:", data); // Log the API response
      return fulfillWithValue(data);
    } catch (error) {
      //console.error("Error updating product:", error);
      // return rejectWithValue(error.response?.data?.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Action for deleting product
export const productDelete = createAsyncThunk(
  "product/productDelete",
  async (productId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(
        `${API_ROUTES.DELETE_PRODUCT}/${productId}`,
        { withCredentials: true },
      );
      //console.log("API Response product delete:", data); // Log the API response
      return fulfillWithValue(data); // Renvoyer la réponse complète
    } catch (error) {
      // console.error("Error deleting product:", error);
      // return rejectWithValue(error.response?.data?.message || error.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Main reducer
export const productReducer = createSlice({
  name: "product",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    products: [],
    product: {},
    totalProduct: 0,
    removedImages: [],
    newImages: [],
  },

  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(productAdd.pending, (state) => {
        state.loader = true;
      })
      .addCase(productAdd.fulfilled, (state, action) => {
        state.loader = false;
        if (action.payload && action.payload.product) {
          state.products = [action.payload.product, ...state.products];
          state.totalProduct += 1;
        }
        state.successMessage = action.payload.message;
      })
      .addCase(productAdd.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage =
          action.payload || "Erreur lors de l'ajout du produit.";
      })
      .addCase(get_products.pending, (state) => {
        state.loader = true;
      })
      .addCase(get_products.fulfilled, (state, action) => {
        state.loader = false;
        state.products = action.payload.products || [];
        state.totalProduct = action.payload.totalProduct || 0;
      })
      .addCase(get_products.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage =
          action.payload || "Erreur lors de la récupération des produits.";
      })

      /*
            .addCase(productAdd.pending, (state) => {
                state.loader = true;
                state.errorMessage = '';
            })
            .addCase(productAdd.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload || "Error adding product";
            })
            .addCase(productAdd.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message; // Ensure 'message' is in response
                state.products = [...state.products, action.payload.product];
            })

            .addCase(get_products.pending, (state) => {
                state.loader = true;
                state.errorMessage = '';
            })
            .addCase(get_products.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload || "Error fetching products";
            })
            .addCase(get_products.fulfilled, (state, action) => {
                state.loader = false;
                state.products = action.payload.products;
                state.totalProduct = action.payload.totalProduct;
            })*/
      .addCase(get_product_by_id.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(get_product_by_id.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload || "Error fetching product";
      })
      .addCase(get_product_by_id.fulfilled, (state, action) => {
        state.loader = false;
        state.product = action.payload.product;
      })
      .addCase(productUpdate.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(productUpdate.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload || "Error updating product";
      })
      .addCase(productUpdate.fulfilled, (state, action) => {
        //  console.log("Mise à jour réussie :", action.payload);
        state.loader = false;
        state.successMessage = action.payload.message;
        state.product = action.payload.product;
        state.removedImages = state.removedImages.filter(
          (image) => image.id !== action.payload.product.id,
        );
        state.newImages = state.newImages.filter(
          (image) => image.id !== action.payload.product.id,
        );
      })
      .addCase(productDelete.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(productDelete.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload || "Error deleting product";
      })
      .addCase(productDelete.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message; // Message de succès
        state.products = state.products.filter(
          (product) => product._id !== action.payload.productId,
        );
        state.totalProduct = state.totalProduct - 1;
      });
  },
});

export const { messageClear } = productReducer.actions;
export default productReducer.reducer;
